import { useEffect, useState } from 'react'

export function useMediaQuery(query: string) {
  const get = () => window.matchMedia(query).matches
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false
    return get()
  })

  useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = () => setMatches(mql.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return matches
}
